import { useQuery } from "react-query";
import { http } from "src/api/http";
import { Fan } from './models';

export function useHqFansAPI() {
  return useQuery<Fan[]>({
    queryKey: ["useHqFans"],
    queryFn: () => http(`/api/my-fans/fans`)
  });
}
